/** Mirrors `DailyRewardSaveModule`'s shape exactly (packages/liveops). */
export class ProgressionSaveModule {
    constructor(userId, _provider) {
        this._provider = _provider;
        this.version = 1;
        this._data = null;
        this._key = `saves/${userId}/modules/progression`;
    }
    getKey() {
        return this._key;
    }
    save(data) {
        this._data = data;
        void this._provider.set(this._key, data);
    }
    load() {
        return this._data;
    }
    migrate(_old, _fromVersion) {
        return { xp: 0, level: 1, version: 1 };
    }
}
